import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { store } from '@user/store/store'
import { selectSourceById } from '@user/store/sources/slice'

export const sourceValueFormatter = ({
  value,
}: GridValueFormatterParams): any =>
  typeof value === 'string'
    ? selectSourceById(store.getState(), value)?.name ?? ''
    : ''
